import { Component, OnInit } from '@angular/core';
import { WizardStep } from '../controls/wizard/wizard.component';
import { SystemsComponent } from '../systems/systems.component';
import { catchError, of, Subscription, tap } from 'rxjs';
import { Events, MsgPayLoad, WebsocketService } from 'src/app/service/websocket.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ActivityService } from 'src/app/service/activity.service';
import { AgentService } from 'src/app/service/agent.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { DataService } from 'src/app/service/data.service';
import { EventService } from 'src/app/service/event.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { Modal } from '../controls/modal/modal.service';
import { ActivityCapabilities, ActivityCapabilitiesRequest, ActivityCapabilitiesType, TaskStatus } from 'src/app/model/TaskStatus';
import { ModalMessageComponent, ModalMessageType } from '../controls/modal-message/modal-message.component';
import { SelectOption } from '../controls/select/select.component';
import { ProductDataType } from '../products/products.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslationUtils } from 'src/app/app-translation-utils';
import { DiscoverProductsRequest, ProductInfo } from 'src/app/model/Product';
import { ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { SolutionService } from 'src/app/service/solution.service';
import { Agent } from 'src/app/model/Agent';
import { Utils } from 'src/app/utils';
import { Environment } from 'src/app/model/SolutionInfo';


enum ManualDiscoverState {
  SELECT = "select",
  QUESTIONS = "questions",
  PRODUCTS = "product",
  LANDSCAPE = "landscape",
  DISCOVER = "discover"
}

export class ManualDiscoverPromptRequest {
  address: string;
  plugin: string;
  constructor(address: string, plugin: string){
    this.address = address;
    this.plugin = plugin;
  }
}

export class ManualDiscoverPromptResponse{
  prompts: Map<string, ManualDiscoverPrompt>;
  isAgentManifestUpdating: boolean;
}

export class ManualDiscoverPrompt {
  order: number;
  message: string;
  label: string;
  value: string;
  placeholder: string;
  control: string;
  required: boolean;
  options: Map<string, string>;
  dependsOnPrompt: string;
  dependsOnPromptValue: string;
  width: number;
  controlId: string
  labelValue: string;
  widthValue: string;
  questionTipValue: string;
  placeholderValue: string;
}

export class ManualDiscoverProductsRequest {
  address: string;
  plugin: string;
  prompts: Map<string, ManualDiscoverPrompt>;
  constructor(address: string, plugin: string, prompts: Map<string, ManualDiscoverPrompt>){
    this.address = address;
    this.plugin = plugin;
    this.prompts = prompts;
  }
}

export class ManualDiscoverProductsResponse {
  isAgentManifestUpdating: boolean;
  products: ProductInfo[];
  prompts: Map<string, ManualDiscoverPrompt>;
  status: TaskStatus;
}

export class ManualDiscoverLandscapeRequest {
  address: string;
  plugin: string;
  prompts: Map<string, ManualDiscoverPrompt>;
  products: ProductInfo[];
  constructor(address: string, plugin: string, prompts: Map<string, ManualDiscoverPrompt>, products: ProductInfo[]){
    this.address = address;
    this.plugin = plugin;
    this.prompts = prompts;
    this.products = products;
  }
}

export class ManualDiscoverLandscapeResponse {
  status: TaskStatus;
}

@Component({
    selector: 'app-systems-manual-discover',
    templateUrl: './systems-manual-discover.component.html',
    styleUrls: ['./systems-manual-discover.component.css'],
    standalone: false
})
export class SystemsManualDiscoverComponent extends SystemsComponent implements OnInit{

  agentInfoSubscription: Subscription;

  steps: WizardStep[] = [
    { 'id': ManualDiscoverState.SELECT, 'name': $localize`Select` },
    { 'id': ManualDiscoverState.QUESTIONS, 'name': $localize`Questions` },
    { 'id': ManualDiscoverState.PRODUCTS, 'name': $localize`Products` },
    { 'id': ManualDiscoverState.LANDSCAPE, 'name': $localize`Landscape` },
    { 'id': ManualDiscoverState.DISCOVER, 'name': $localize`Discover` }];

  index: number = 0;
  state: ManualDiscoverState = ManualDiscoverState.SELECT;
  ManualDiscoverState = ManualDiscoverState;

  backButtonId: string;
  nextButtonId: string;
  cancelButtonId: string;
  retryButtonId: string;

  isLoading: boolean = false;
  isDiscovering: boolean = false;
  isDiscoverComplete: boolean = false;
  isAgentManifestUpdating: boolean = false;
  isWaitingForManualDiscoverPrompts: boolean = false;
  isValidating: boolean = false;
  isCreatingLandscape: boolean = false;
  isError: boolean = false;
  errorMessage: string;

  productMap: Map<string, string>;
  productOptions: SelectOption[] = [];
  selectedProduct: SelectOption;

  promptsList: string[] = [];
  promptsOrderList: string[] = [];
  questionsForm: FormGroup;

  manualDiscoverPromptResponse: ManualDiscoverPromptResponse;
  manualDiscoverValidateResponse: ManualDiscoverProductsResponse;
  manualDiscoverLandscapeResponse: ManualDiscoverLandscapeResponse;

  prompts: Map<string, ManualDiscoverPrompt>;

  instanceCols: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "23"),
    new DataTableColumn("productName", $localize`Product`, ColumnType.STRING, false, "22"),
    new DataTableColumn("productVersion", $localize`Version`, ColumnType.STRING, false, "10"),
    new DataTableColumn("installationDirectory", $localize`Install Path`, ColumnType.STRING, false, "30"),
    new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "15")
  );

  instanceRows: DataTableRow[] = [];
  landscapeRows: DataTableRow[] = [];

  discoverActivity: number;
  selectedSystemId: string;
  selectedSystem: Agent = undefined;
  selectedEnvironment: Environment;
  solutionInfoSubscription: Subscription;
  eventMessageSubscription: Subscription;
  
  constructor(
    protected agentService: AgentService,
    protected eventService: EventService,
    protected router: Router,
    protected dataService: DataService,
    protected route: ActivatedRoute,
    protected modal: Modal,
    protected wsService: WebsocketService,
    protected authService: AuthenticationService,
    protected activityService: ActivityService,
    protected softwareService: SoftwareInventoryService,
    protected solutionService: SolutionService) {
    super(agentService, eventService, router, dataService, route, modal, wsService, authService, activityService, solutionService);

  }

  ngOnInit(): void {

    this.routerSubscription = this.route.params.subscribe(params => {
      this.selectedSystemId = params["agentId"];
    });

    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.solutionInfo = newSolutionInfo;
      if(this.state == ManualDiscoverState.SELECT){
        this.getAgent();
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.ActivityCapabilities){
        this.processActivityCapabilities(msg);
      } else if (msg.eventType == Events.ManualDiscoverPrompts){
        this.processManualPrompts(msg);
      } else if (msg.eventType == Events.ManualDiscoverValidate){
        this.processValidate(msg);
      } else if (msg.eventType == Events.ManualDiscoverLandscape){
        this.processLandscape(msg);
      } else if (msg.eventType == Events.ActivityRefresh){
        if(this.isDiscovering){
          this.getActivty(this.discoverActivity);
        }
      }
    });
  }

  getProductNameForPlugins() {
    this.isLoading = true;
    this.softwareService.getProductNameForPlugins().pipe(
      tap(resp => {
        this.productMap = resp.body;
        this.getProductCapabilities();
      }),
      catchError(resp => {
        this.isLoading = false;
        this.isError = true;
        this.errorMessage = $localize`Failed to request the list of compatible products, please try again.`
        return of(resp);
      })).subscribe();
  }

  getProductCapabilities(): void {
    this.softwareService.sendActivityCapabilities(this.wsService.getClientId(), this.selectedEnvironment.id, this.addTransaction(),
    new ActivityCapabilitiesRequest(-1, ActivityCapabilitiesType.PRODUCT_CAPABILITIES, "*", '')).pipe(
    tap(resp => {
    }),
    catchError(resp => {
      this.isLoading = false;
      this.isError = true;
      this.errorMessage = $localize`Failed to retrieve the list of product capabilities, please try again.`
      return of(resp);
    })).subscribe();
  }

  getManualDiscoverPrompts(): void {
    this.softwareService.sendManualDiscoverPrompts(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(), 
      new ManualDiscoverPromptRequest(this.selectedSystem.macAddress, this.selectedProduct.value)).pipe(
        tap(resp => {
        }),
        catchError(resp => {
          this.isWaitingForManualDiscoverPrompts = false;
          this.isError = true;
          this.errorMessage = $localize`Failed to request the list of questions, please try again.`
          return of(resp);
        })).subscribe();
  }

  getManualDiscoverValdiate(): void {
    this.softwareService.sendManualDiscoverValidate(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(), 
    new ManualDiscoverProductsRequest(this.selectedSystem.macAddress, this.selectedProduct.value, this.prompts)).pipe(
      tap(resp => {
      }),
      catchError(resp => {
        this.isValidating = false;
        this.isError = true;
        this.errorMessage = $localize`Failed to request the search of available products, please try again.`
        return of(resp);
      })).subscribe();
  }

  createManualDiscoverLandscape(): void {
    let tmpProduct: ProductInfo[] = [];
    this.landscapeRows = [];
    this.instanceRows.forEach(row =>{
      if(row.selected){
        for(let i = 0; i < this.manualDiscoverValidateResponse.products.length; i++){
          if(this.manualDiscoverValidateResponse.products[i].installationDirectory == row.data.installationDirectory){
            tmpProduct.push(this.manualDiscoverValidateResponse.products[i]);
            let instanceData: any = {};
            instanceData.system = this.selectedSystem.systemName;
            instanceData.productName = this.manualDiscoverValidateResponse.products[i].productName;
            instanceData.productVersion = this.manualDiscoverValidateResponse.products[i].productVersion;
            instanceData.installationDirectory = this.manualDiscoverValidateResponse.products[i].installationDirectory;
            instanceData.platform = this.selectedSystem.osName;
            this.landscapeRows.push(new DataTableRow(instanceData, []));
            break;
          }
        }
      }
    });

    this.isCreatingLandscape = true;
    this.softwareService.sendManualDiscoverLandscape(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(), 
    new ManualDiscoverLandscapeRequest(this.selectedSystem.macAddress, this.selectedProduct.value, this.prompts, tmpProduct)).pipe(
      tap(resp => {
      }),
      catchError(resp => {
        this.isCreatingLandscape = false;
        this.isError = true;
        this.errorMessage = $localize`Failed to request the creation of landscape files, please try again.`
        return of(resp);
      })).subscribe();
  }

  sendDiscoverProducts(){
    this.isDiscovering = true;
    this.softwareService.sendDiscoverProducts(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
    new DiscoverProductsRequest(this.selectedSystem.macAddress, this.authService.getLoggedInUser().userName, true)).pipe(
      tap(resp => {
        this.discoverActivity = resp.body;
      }),
      catchError(resp => {
        this.isError = true;
        this.errorMessage = $localize`Failed to request the discovery of new found products, please try again.`
        return of(resp);
      })).subscribe();
  }

  getActivty(id: number) {
    if(id > -1){
      this.activityService.getActivityById(id).pipe(
        tap(resp => {
          if(resp.body.status === "COMPLETED" || resp.body.status === "ERROR"){
            this.discoverActivity = -1;
            this.isDiscoverComplete = true;
            if(resp.body.status === "ERROR"){
              this.isError = true;
              for(let i = 0; i < resp.body.taskList.length; i++){
                if(resp.body.taskList[i].errorMessage && resp.body.taskList[i].errorMessage != ""){
                  this.errorMessage = resp.body.taskList[i].errorMessage;
                  break;
                }
              }
            }
            this.isDiscovering = false;
          }
        })).subscribe();
    }
  }

  processActivityCapabilities(msg: MsgPayLoad){
    let productCapabilties: ActivityCapabilities[] = JSON.parse(msg.body.msg);
    if(productCapabilties){
      this.productOptions = [];
      productCapabilties.forEach(productCapability=>{
        if(productCapability.supportsManualDiscover){
          this.productOptions.push(new SelectOption(productCapability.plugin, this.productMap[productCapability.plugin],
            false, false));
        }
      });
    }
    this.isLoading = false;
  }

  onProductSelected(item: SelectOption): void {
    this.selectedProduct = item;
  }

  validateSelected(): void {
    let errorMessage: string = "";
    if (!this.selectedSystem.isOnline) {
      errorMessage = $localize`The selected system is offline.  Please validate the system's status and try again.`;
    } else if (!this.selectedSystem.isAuthorized) {
      errorMessage = $localize`The selected system is not authorized to perform this action.  Please validate the system's status and try again.`;
    } else if (!this.selectedSystem.isActive) {
      errorMessage = $localize`The selected system has been disabled.  Please validate the system's status and try again.`;
    }

    if (errorMessage != "" && this.state != ManualDiscoverState.DISCOVER && !this.isDiscovering) {
      const sub: Subscription =
        this.modal.open(ModalMessageComponent, {
          data: {
            type: ModalMessageType.Error,
            title: $localize`Error`,
            message: errorMessage,
            primaryBtn: $localize`Close`,
            width: '500px'
          },
          id: 'otsc-manual-discover-error-dialog'
        }).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
          if (isPrimaryBtnClicked) {
            this.cancel();
          }
          sub.unsubscribe();
        });
    }
  }

  processManualPrompts(msg: MsgPayLoad){
    if(msg.body.ok){
      let tmpManualDiscoverPromptResponse: ManualDiscoverPromptResponse = JSON.parse(msg.body.msg);

      if(tmpManualDiscoverPromptResponse.isAgentManifestUpdating){
        this.isAgentManifestUpdating = true;
        this.dataService.sendData({type: ProductDataType.AgentManifest, isAgentManifestUpdating: this.isAgentManifestUpdating});
      } else {
        let keys = Object.keys(tmpManualDiscoverPromptResponse.prompts);
        this.promptsOrderList = [];
        let controls: any = {};


        keys.forEach(key => {
          if(this.promptsList.indexOf(key) == -1){
            let prompt: ManualDiscoverPrompt = tmpManualDiscoverPromptResponse.prompts[key];
            prompt.controlId = key;
            prompt.labelValue = TranslationUtils.getManualDiscoverQuestionsLabel(prompt);
            prompt.widthValue = this.getPromptWidth(prompt);
            prompt.questionTipValue = '';//TranslationUtils.getQuestionsTip(prompt);
            prompt.placeholderValue = '';//TranslationUtils.getQuestionPlaceHolder(prompt);
            controls[prompt.controlId] = prompt.required ? 
            new FormControl(prompt.value, Validators.required) :
            new FormControl(prompt.value);
            this.promptsList[prompt.order] = prompt.controlId;
          }
        });

        if(Object.keys(controls).length > 0) {
          this.manualDiscoverPromptResponse = tmpManualDiscoverPromptResponse;
          this.prompts = this.manualDiscoverPromptResponse.prompts;
          this.questionsForm = new FormGroup(controls);
        }
      }
    }else{
      this.isError = true;
      this.errorMessage = "Failed to retrieve the list of product questions, please try again.";
    }
    this.isWaitingForManualDiscoverPrompts = false;
  }

  processValidate(msg: MsgPayLoad){
    this.instanceRows = [];
    this.manualDiscoverValidateResponse = JSON.parse(msg.body.msg);
    if(this.manualDiscoverValidateResponse.status.completed && this.manualDiscoverValidateResponse.status.success){
      if(this.manualDiscoverValidateResponse.products.length > 0){
        this.manualDiscoverValidateResponse.products.forEach(product =>{
          let instanceData: any = {};
          instanceData.system = this.selectedSystem.systemName;
          instanceData.productName = product.productName;
          instanceData.productVersion = product.productVersion;
          instanceData.installationDirectory = product.installationDirectory;
          instanceData.platform = this.selectedSystem.osName;
          this.instanceRows.push(new DataTableRow(instanceData, []));
        });
      } else {
        this.isError = true;
        this.errorMessage = $localize`No products found.`;
      }
    } else {
      this.isError = true;
      this.errorMessage = this.manualDiscoverValidateResponse.status.errorMessage;
    }
    this.isValidating = false;
  }

  processLandscape(msg: MsgPayLoad){
    this.manualDiscoverLandscapeResponse = JSON.parse(msg.body.msg);
    if(this.manualDiscoverLandscapeResponse.status.completed){
      if(!this.manualDiscoverLandscapeResponse.status.success){
        this.isError = true;
        this.errorMessage = this.manualDiscoverLandscapeResponse.status.errorMessage;
      }
    }
    this.isCreatingLandscape = false;
  }

  getSelectedRowCount(): number{
    let count: number = 0;
    if(this.instanceRows){
      this.instanceRows.forEach(row =>{
        if(row.selected){
          count++;
        }
      });
    }
    return count;
  }

  getPromptWidth(prompt: ManualDiscoverPrompt): string {
    return (prompt.width == 0) ? "100%" : prompt.width + "px";
  }

  getPromptsByOrder(): ManualDiscoverPrompt[] {
    let prompts: ManualDiscoverPrompt[] = [];
    this.promptsList.forEach(key =>{
      if(this.manualDiscoverPromptResponse.prompts[key] != undefined){
        prompts.push(this.manualDiscoverPromptResponse.prompts[key]);
      }
    });
    return prompts;
  }

  showPrompt(key: string, prompt: ManualDiscoverPrompt): boolean {
    let show: boolean = false;
    if(prompt.dependsOnPrompt && prompt.dependsOnPrompt != ""){
      let dependsPromptObj: any = this.manualDiscoverPromptResponse.prompts[prompt.dependsOnPrompt];
      show = (prompt.dependsOnPrompt == undefined || prompt.dependsOnPrompt == null) ? true :
        (dependsPromptObj.value == prompt.dependsOnPromptValue);
    } else {
      show = true;
    }

    if(show){
      this.questionsForm.controls[key].enable();
    } else {
      this.questionsForm.controls[key].disable();
    }
    
    return show;
  }

  private showQuestionsError(prompt: string): boolean{
    let showError = false;
    if(this.questionsForm !== undefined){
      let control  = this.questionsForm.controls[prompt];
      showError = (control.touched && control.invalid && control.errors.required);
    }
    return showError;
  }

  private canShowPasswords(): boolean {
    let show: boolean = false;

    if(this.manualDiscoverPromptResponse !== undefined) {
      if(Object.keys(this.manualDiscoverPromptResponse.prompts).length > 0){
        let keys = Object.keys(this.manualDiscoverPromptResponse.prompts);

        for(var i = 0; i < keys.length; i++){
          var item = this.manualDiscoverPromptResponse.prompts[keys[i]];
          if(item.control == 'PASSWORD'){
            show = true;
            break;
          }
        }
      }
    }

    return show;
  };

  next(): void {
    switch(this.state) {
      case ManualDiscoverState.SELECT:
        this.goToQuestions();
        break;
      case ManualDiscoverState.QUESTIONS:
        this.goToProducts();
        break;
      case ManualDiscoverState.PRODUCTS:
        this.goToLandscape();
        break;
      case ManualDiscoverState.LANDSCAPE:
        this.goToDiscover();
        break;
      case ManualDiscoverState.DISCOVER:
        this.router.navigate(["/systems/details/", this.selectedSystem.agentID]);
        break;
    }
  }

  back(): void {
    this.isError = false;
    this.errorMessage = "";
    switch(this.state) {
      case ManualDiscoverState.QUESTIONS:
        this.goToSelect();
        break;
      case ManualDiscoverState.PRODUCTS:
        this.goToQuestions();
        break;
      case ManualDiscoverState.LANDSCAPE:
        this.goToProducts();
        break;
    }
  }

  retry(): void {
    this.isError = false;
    this.errorMessage = "";
    switch(this.state) {
      case ManualDiscoverState.SELECT:
        this.goToSelect();
        break;
      case ManualDiscoverState.QUESTIONS:
        this.goToQuestions();
        break;
      case ManualDiscoverState.PRODUCTS:
        this.goToProducts();
        break;
      case ManualDiscoverState.LANDSCAPE:
        this.goToLandscape();
        break;
    }
  }

  cancel(): void {
    this.router.navigate(["/systems/details/", this.selectedSystem.agentID]);
  }

  isNextDisabled(): boolean {
    let isDisabled = false;
    switch(this.state) {
      case ManualDiscoverState.SELECT:
        isDisabled =  this.isError || !this.selectedProduct;
        break;
      case ManualDiscoverState.QUESTIONS:
        isDisabled = this.isError || this.isWaitingForManualDiscoverPrompts || (this.questionsForm !== undefined && this.questionsForm.invalid);
        break;
      case ManualDiscoverState.PRODUCTS:
        isDisabled = this.isError || this.isValidating || this.getSelectedRowCount() == 0;
        break;
      case ManualDiscoverState.LANDSCAPE:
        isDisabled = this.isError || this.isCreatingLandscape;
        break;
      case ManualDiscoverState.DISCOVER:
        isDisabled = this.isError || this.isDiscovering;
        break;
    }
    return isDisabled;
  }

  isCancelDisabled(): boolean {
    let isDisabled = false;
    switch(this.state) {
      case ManualDiscoverState.QUESTIONS:
        isDisabled = this.isWaitingForManualDiscoverPrompts;
        break;
      case ManualDiscoverState.PRODUCTS:
        isDisabled = this.isValidating;
        break;
      case ManualDiscoverState.LANDSCAPE:
        isDisabled = this.isCreatingLandscape;
        break;
      case ManualDiscoverState.DISCOVER:
        isDisabled = this.isDiscovering;
        break;
    }
    return isDisabled;
  }

  isBackDisabled(): boolean {
    let isDisabled = false;
    switch(this.state) {
      case ManualDiscoverState.QUESTIONS:
        isDisabled = this.isWaitingForManualDiscoverPrompts;
        break;
      case ManualDiscoverState.PRODUCTS:
        isDisabled = this.isValidating;
        break;
      case ManualDiscoverState.LANDSCAPE:
        isDisabled = this.isCreatingLandscape;
        break;
      case ManualDiscoverState.DISCOVER:
        isDisabled = this.isDiscovering;
        break;
    }
    return isDisabled;
  }

  showBack(): boolean {
    let show = false;
    switch(this.state) {
      case ManualDiscoverState.QUESTIONS:
      case ManualDiscoverState.PRODUCTS:
      case ManualDiscoverState.LANDSCAPE:
        if(this.manualDiscoverLandscapeResponse && 
          this.manualDiscoverLandscapeResponse.status.success){
          show = false;
        } else {
          show = true;
        }
        break;
      case ManualDiscoverState.DISCOVER:
        show = false;
        break;
    }
    return show;
  }

  showNext(): boolean {
    let show = false;
    switch(this.state) {
      case ManualDiscoverState.SELECT:
      case ManualDiscoverState.QUESTIONS:
      case ManualDiscoverState.PRODUCTS:
      case ManualDiscoverState.LANDSCAPE:
        show = true;
        break;
      case ManualDiscoverState.DISCOVER:
        show = !this.isDiscoverComplete;
        break;
    }
    return show;
  }


  goToSelect(): void {
    this.nextButtonId = "discover-select-next-button";
    this.cancelButtonId = "discover-select-cancel-button";
    this.retryButtonId = "discover-select-retry-button";
    this.getProductNameForPlugins();
    this.index = 0;
    this.state = ManualDiscoverState.SELECT;
  }

  goToQuestions(): void {
    this.backButtonId = "discover-questions-back-button";
    this.nextButtonId = "discover-questions-next-button";
    this.cancelButtonId = "discover-questions-cancel-button";
    this.retryButtonId = "discover-questions-retry-button";
    this.isWaitingForManualDiscoverPrompts = true;
    this.getManualDiscoverPrompts();
    this.index = 1;
    this.state = ManualDiscoverState.QUESTIONS;
  }

  goToProducts(): void {
    this.backButtonId = "discover-products-back-button";
    this.nextButtonId = "discover-products-next-button";
    this.cancelButtonId = "discover-products-cancel-button";
    this.retryButtonId = "discover-products-retry-button";
    this.isValidating = true;
    this.getManualDiscoverValdiate();
    this.index = 2;
    this.state = ManualDiscoverState.PRODUCTS;
  }

  goToLandscape(): void {
    this.backButtonId = "discover-landscape-back-button";
    this.nextButtonId = "discover-landscape-next-button";
    this.cancelButtonId = "discover-landscape-cancel-button";
    this.retryButtonId = "discover-landscape-retry-button";
    this.createManualDiscoverLandscape();
    this.index = 3;
    this.state = ManualDiscoverState.LANDSCAPE;
  }

  goToDiscover(): void {
    this.sendDiscoverProducts();
    this.index = 4;
    this.state = ManualDiscoverState.DISCOVER;
  }

  isSelectedSystem(): boolean {
    return this.selectedSystem !== undefined;
  }

  getAgent(): void {
    this.agentService.getAgent(this.selectedSystemId).pipe(
      tap(resp => {
        this.selectedSystem = resp.body;
        if (this.selectedSystem.description == undefined || this.selectedSystem.description == "undefined") {
          this.selectedSystem.description = "";
        }
        
        if(this.selectedSystem.environments && this.selectedSystem.environments.length > 0){
          this.selectedEnvironment = this.selectedSystem.environments[0];
          this.validateSelected();
          this.goToSelect();
        }else{
          let msg = new MsgPayLoad(undefined, {
            message: $localize`This system is not registered to any envionments. Please register to an environment before enabling a product.`
          });
          msg.setEvent(Events.ErrorMsg);
          Utils.addHeaderMessageBanner(this.eventService, msg);
          this.cancel();
        }
      }),
      catchError(resp => {
        let msg = new MsgPayLoad(undefined, {
          message: $localize`Error getting the system information. Please try again.`
        });
        msg.setEvent(Events.ErrorMsg);
        Utils.addHeaderMessageBanner(this.eventService, msg);
        this.back();
        return of(resp);
      })).subscribe();
  }
}